<template>
  <el-form
    class="app-form"
    :validate-on-rule-change="false"
    :model="model"
    :rules="rules"
    label-width="120px"
    ref="form"
  >
    <el-form-item
      v-for="(item, index) in filter(model)"
      :key="index"
      v-bind="item"
    >
      <el-input
        v-if="item.type == 'text' || !item.type"
        v-bind="item"
        v-model="item.value"
        :readonly="item.readonly"
      />
      <el-input-number
        v-else-if="item.type == 'number'"
        v-bind="item"
        v-model="item.value"
        :readonly="item.readonly"
      />
      <el-input
        v-else-if="item.type == 'textarea'"
        v-bind="item"
        v-model="item.value"
        :readonly="item.readonly"
      />
      <el-select
        v-else-if="item.type == 'select'"
        v-bind="item"
        v-model="item.value"
        filterable
        allow-create
        clearable
        :readonly="item.readonly"
      >
        <el-option v-for="(value, i) in item.values" :key="i" :value="value" />
      </el-select>
      <el-date-picker
        v-else-if="item.type == 'date'"
        v-bind="item"
        v-model="item.value"
        value-format="yyyy-MM-dd"
        placeholder="选择日期"
        allow-create
        filterable
        :readonly="item.readonly"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item>
      <el-button v-if="type != 'detail'" type="primary" @click="onSubmit">
        {{ text }}
      </el-button>
      <el-button v-if="type != 'detail'" type="warning" @click="onReset">
        重置
      </el-button>
      <el-button @click="onBack">
        返回
      </el-button>
    </el-form-item>
    <el-backtop />
  </el-form>
</template>

<script>
import api from '@/api';

export default {
  props: {
    // 是否只读
    readonly: {
      type: Boolean,
      default: false
    },
    // 表单模型
    model: {
      type: Object,
      default: null
    },
    // 验证规则
    rules: {
      type: Object,
      default: null
    },
    // 类型
    type: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      loading: null
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    text() {
      const { type } = this;
      if (type == 'create') {
        return '创建';
      } else if (type == 'update') {
        return '更新';
      } else {
        return '提交';
      }
    },
    payload() {
      const { id, model } = this;
      let payload = {};
      if (id) {
        payload.id = id;
      }
      for (const key in model) {
        payload[key] = model[key].value;
      }
      return payload;
    }
  },
  async created() {
    await this.getItem();
  },
  methods: {
    // 编号不显示
    filter(value) {
      delete value.id;
      return value;
    },
    // 填充下拉框
    async getSelects() {
      const { type, model } = this;
      if (type != 'detail') {
        for (const key in model) {
          // eslint-disable-next-line no-prototype-builtins
          if (model.hasOwnProperty(key)) {
            const elem = model[key];
            if (elem.type == 'select') {
              const { data } = await api.dict.listAll({ type: elem.arg });
              elem.values = data.map(item => item.name);
            }
          }
        }
      }
    },
    // 加载详情
    async getItem() {
      try {
        this.loading = this.$loading({ target: '.app-main' });
        const { type, id, model } = this;
        await this.getSelects();
        // 请求
        if (type != 'create') {
          const { data } = await api.business.detail({ id });
          for (const key in data) {
            // eslint-disable-next-line no-prototype-builtins
            if (model.hasOwnProperty(key)) {
              model[key].value = data[key];
            }
          }
        }
      } finally {
        this.loading.close();
      }
    },
    // 表单创建或者更新
    async onSubmit() {
      try {
        this.loading = this.$loading({ target: '.app-main' });
        const { type, payload } = this;
        await this.$refs.form.validate();
        let result;
        if (type == 'create') {
          result = await api.business.create(payload);
        } else if (type == 'update') {
          result = await api.business.update(payload);
        }
        const { message } = result;
        this.$notify({ title: '成功', message, type: 'success' });
        this.$router.back();
      } catch {
        this.$message({ message: '请完善表单', type: 'error' });
      } finally {
        this.loading.close();
      }
    },
    // 重置表单
    async onReset() {
      await this.$refs.form.resetFields();
    },
    // 返回
    async onBack() {
      await this.$router.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.app-form {
  width: 600px;
}
</style>
